import * as React from 'react'

import { observer } from 'mobx-react'

import hasFeature from 'modules/core/lib/hasFeature'

import PolicyBreaks from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyBreaks'
import PolicyDetails from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyDetails'
// TODO: using parent private components
import PolicyEmployees from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyEmployees'
import PolicyOvertime from 'modules/attendance/components/SettingItemPage/TimeTracking/PolicyOvertime'
import { TabTypes } from 'modules/attendance/components/SettingItemPage/TimeTracking/tabs'
import type AttendancePolicy from 'modules/attendance/store/models/AttendancePolicy'
import type AttendanceSetting from 'modules/attendance/store/models/AttendanceSetting'

import Compensation from '../../Compensation'
import WorkTimeCategories from '../../WorkTimeCategories'

interface ContentProps {
  tabId?: string
  attendancePolicy: AttendancePolicy | null | undefined
  attendanceSetting: AttendanceSetting | null | undefined
}

const Content = ({ tabId, attendancePolicy, attendanceSetting }: ContentProps) => {
  const hasMajorationEnabled = hasFeature('dev_time_tracking_majoration')
  const hasBankOfHours = hasFeature('dev_time_tracking_bank_of_hours')

  if (!attendancePolicy || !attendanceSetting) return null

  switch (tabId) {
    case TabTypes.edit:
      return (
        <PolicyDetails attendancePolicy={attendancePolicy} attendanceSetting={attendanceSetting} />
      )

    case TabTypes.employees:
      return (
        <PolicyEmployees
          attendancePolicy={attendancePolicy}
          attendanceSetting={attendanceSetting}
        />
      )

    case TabTypes.preferences:
      return <PolicyOvertime attendanceSetting={attendanceSetting} />

    case TabTypes.breaks:
      return <PolicyBreaks attendanceSetting={attendanceSetting} />

    case TabTypes.compensation:
      return <Compensation attendanceSetting={attendanceSetting} />

    case TabTypes.work_time_categories:
      if (hasMajorationEnabled || hasBankOfHours) {
        return <WorkTimeCategories attendanceSetting={attendanceSetting} />
      }
    default:
      return null
  }
}

export default observer(Content)
